/**
 * Which build this page is.
 *
 * `dev` is the honest answer under `npm run dev`, where nothing sets the var —
 * but it was also the answer on the **live site**, on every deploy, until
 * 2026-08-29: the CDK bundling container never passed `VITE_BUILD_HASH`, so
 * the stamp had never once worked in production. `pinobo-backend/infra` now
 * reads the short commit on the host at synth time and passes it in.
 *
 * The slice is 8, not 7, because a build made from a dirty tree is stamped
 * `abc1234+` and the `+` is the part worth seeing.
 */
const BUILD_HASH = (import.meta.env.VITE_BUILD_HASH ?? 'dev').toString().slice(0, 8)
const YEAR = new Date().getFullYear()

export function Footer() {
  return (
    <footer className="mt-32 border-t border-[color:var(--color-line)] px-6 py-10 font-mono text-xs uppercase tracking-[0.2em] text-[color:var(--color-muted)] md:px-10">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div className="space-y-2">
          <div>Christos Alatzidis</div>
          <div className="text-[color:var(--color-fg)]/60">
            <a
              href="mailto:christos@alatzidis.com"
              className="transition-colors hover:text-[color:var(--color-fg)]"
            >
              christos@alatzidis.com
            </a>
          </div>
        </div>

        <div className="space-y-2 md:text-right">
          <div>Built by pinobo · {YEAR}—</div>
          <div className="text-[color:var(--color-fg)]/40">build {BUILD_HASH}</div>
        </div>
      </div>
    </footer>
  )
}
